import { SOCIAL_CALLBACK } from "constants/api";
import axios, { AxiosError } from "axios";
import { signInWithCustomToken, getAuth } from 'firebase/auth'
import { dlTrackEvent } from "components/dataLayer/dataLayer";
import { useContext, useState } from "react";
import FacebookIcon from 'components/icon/facebook'
import { LoaderContext } from "contexts/loader-context";
import { IBodyLoginExternal } from "../auth";

export default function FacebookSDK({ handleSubmit, setError }: { handleSubmit: ({ bodyLogin }: { bodyLogin: any; }) => Promise<void>, setError: (error: string | number) => void }) {
  const { setLoad } = useContext(LoaderContext)
  const [buttonFacebook, setButtonFacebook] = useState<{ click: () => void; }>()
  const firbaseAuth = getAuth()

  const handleClick = async (response: any) => {
    setLoad(true)
    try {
      dlTrackEvent('user_interaction', {
        action: "click",
        element: 'facebook',
        section: "login"
      })
      gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'Click - Google', value: 'Google' })
      const { data } = await axios.get(`${SOCIAL_CALLBACK}facebook/signin?code=${response?.authResponse?.accessToken}`, {
        headers: {
          'PH-Api-ID': PH_API_ID
        }
      })
      const firebaseLogin = await signInWithCustomToken(firbaseAuth, data.firebaseAccessToken)
      const names = firebaseLogin.user?.displayName?.split(' ') || ['', '']
      const email = firebaseLogin.user?.email
      const firstName = names[0]
      const lastName = names[names.length - 1]

      const bodyLogin: IBodyLoginExternal = {
        accessToken: data?.providerAccessToken,
        firstName,
        lastName,
        email,
        provider: 'Facebook'
      }

      return await handleSubmit({ bodyLogin })
    } catch (error) {
      const code = (error as AxiosError).response?.data.code || 99999
      setError(code)
    } finally {
      setLoad(false)
    }
  }

  window.onload = () => {
    const createFakeFacebookWrapper = () => {

      return {
        click: () => {
          window.FB.login((response) => {
            if (response?.authResponse) {
              handleClick(response)
            } else {
              console.log('User cancelled login or did not fully authorize.');
            }
          }, { scope: 'email,user_birthday,user_likes' });
        },
      };
    };

    setButtonFacebook(createFakeFacebookWrapper())
  }

  return (
    <>
      {
        buttonFacebook && (
          <FacebookIcon className='google' onClick={() => buttonFacebook.click()} />
        )
      }
    </>
  )
}